import React, { Component } from 'react'
import Select from 'react-select';
import api from '../../services/api';
import moment from 'moment';
import { toast } from 'react-toastify';
import Logo from '../../assets/logo.png';
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable';

class RelatorioPorServico extends Component {

    constructor(props){
        super(props);
        
        
        this.state = {
            isLoandingPage: false,
            isPreview: false,
            servicos:'',
            servico:'', 
            grupos:'',
            grupo:'',
            totalQuantidade:0,
            totalValor:0,
            viewReports: []
        }   
        this.imprimir           = this.imprimir.bind(this)     
        this.executar           = this.executar.bind(this)      
        this.voltar             = this.voltar.bind(this)
      
    }

    async componentDidMount() {
        const token    = sessionStorage.getItem('token');

        this.setState({isLoandingPage: true});

       
        const listarServicos = await api.get('/api/servico', {
            headers: {
                'x-access-token':token,
            }
        });

        const listarGrupos = await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        })

        const grupos = [];
 
        listarGrupos.data.forEach(element => {
            grupos.push({value: element.id, label:element.nome })            
        });


        const servicos = [];
 
        listarServicos.data.forEach(element => {
            servicos.push({value: element.id, label:element.nome })            
        });

        console.log(servicos)
        let hoje = new Date();
        this.setState({
            isLoandingPage: false,
            isPreview: false,
            servicos:servicos,
            servico:'',
            grupos: grupos,
            grupo:'',
            totalQuantidade:0,
            totalValor:0,
            viewReports: []            
        })  
        this.setState({isLoandingPage: false});
    }

    imprimir = async ( items ) => {

        const licenciada    = sessionStorage.getItem('razao');
        
        const doc = new jsPDF()
        var hoje = new Date();
        var hsemissao = hoje.toISOString().split("T")[1].split(".")[0]
        var dtemissao = hoje.toISOString().split("T")[0].split("-").reverse().join("/")
      
        var body = [...this.state.viewReports.map((el) => [el.nome, Number(el.pr1).toFixed(2), Number(el.pr2).toFixed(2), Number(el.pr3).toFixed(2)]), 
        [{content: `Total = ${this.state.viewReports.length}`, colSpan: 5, 
        styles: { fillColor: [239, 154, 154] }
        }]]
                
        autoTable(doc, {            
            head: [['Serviço','Preço 01', 'Preço 02', 'Preço 03']],
            body: body,
            startY: 22, 
            didDrawPage: function (data) {
                doc.setFontSize(12)
                doc.text(`Empresa: ${ licenciada }`, 30, 12)
                doc.text(`Data: ${dtemissao}`, 30, 16)
                doc.text(`Hora: ${hsemissao}`, 30, 20)
            
                doc.setFontSize(11)
                doc.addImage(Logo, 'JPEG', data.settings.margin.left, 5, 15, 15);
            }
            
        })
        doc.save(`${hoje.getTime().toString()}.pdf`)
       
    }

    executar = async() => {
        const token    = sessionStorage.getItem('token');        
        const { servico, grupo } = this.state;
        
        const tabelas = await api.post('/api/tabelapreco', { servico, grupo }, {
            headers: {
                'x-access-token':token,
            }
        })
        
        this.setState({
            isPreview: true,
            isLoandingPage: true,
            servicos:tabelas.data,
            servico:servico,
            totalValor:0,
            viewReports: tabelas.data
        })
    }

    voltar = async() => {
        const token    = sessionStorage.getItem('token');

        this.setState({isLoandingPage: true});

        const listarServicos = await api.get('/api/servico', {
            headers: {
                'x-access-token':token,
            }
        });

        const listarGrupos = await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        })

        const servicos = [];
 
        listarServicos.data.forEach(element => {
            servicos.push({value: element.id, label:element.nome })            
        });


        const grupos = [];
 
        listarGrupos.data.forEach(element => {
            grupos.push({value: element.id, label:element.nome })            
        });

        let hoje = new Date();
        this.setState({
            isLoandingPage: false,
            isPreview: false,
            servicos:servicos,
            servico:'',
            grupos: grupos,
            grupo:'',
            totalQuantidade:0,
            totalValor:0,
            viewReports: []            
        })  
        this.setState({isLoandingPage: false});
    }
    
    render() {        
        return ( 
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                           
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title"><i class="fas fa-file-pdf"></i> Tabela de Preço</h3>

                                <div className="card-tools">
                                    <button type="button" className="btn btn-tool" data-card-widget="Atualizar" data-toggle="Atualizar" title="Atualizar" onClick={ () => {} }>
                                        <i className="fas fa-sync"></i>
                                    </button>
                                
                                    <button type="button" className="btn btn-tool" data-card-widget="Minimizar" data-toggle="Minimizar" title="Minimizar">
                                        <i className="fas fa-minus"></i>
                                    </button>
                                
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
                                            <li className="nav-item">
                                                <a className={ `nav-link ${ !this.state.isPreview ? 'active' : ''}`} id="custom-tabs-listagem-dados-tab" data-toggle="pill" onClick={ () => {}} href="#custom-tabs-listagem-dados" role="tab" aria-controls="custom-tabs-listagem-dados" aria-selected={ this.state.isPreview  ? true : false }>Variáveis</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={ `nav-link ${ this.state.isPreview ? 'active' : ''}` } id="custom-tabs-edicao-dados-tab" data-toggle="pill" onClick={() =>{} } href="#custom-tabs-edicao-dados" role="tab" aria-controls="custom-tabs-edicao-dados" aria-selected={ !this.state.isPreview  ? true : false }>Relatório</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        
                                        <div className="tab-content" id="custom-tabs-two-tabContent">
                                            <div className={`tab-pane ${ this.state.isPreview ? 'tab-pane fade' : 'fade show active' }`} id="vert-tabs-lista" role="tabpanel" aria-labelledby="vert-tabs-lista-tab">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class="form-group">
                                                            <label>Grupo</label>
                                                            <Select
                                                                id="grupo"
                                                                placeholder="Selecione" 
                                                                isSearchable="true"
                                                                options={this.state.grupos}
                                                                onChange={e => this.setState({grupo: e.value})}
                                                            />
                                                        </div>
                                                    </div>  
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class="form-group">
                                                            <label>Servicos</label>
                                                            <Select
                                                                id="servico"
                                                                placeholder="Selecione" 
                                                                isSearchable="true"
                                                                options={this.state.servicos}
                                                                onChange={e => this.setState({servico: e.value})}
                                                            />
                                                        </div>
                                                    </div>                                                          
                                                </div>
                                                
                                                <div className="card-footer clearfix">
                                                    <button type="button" class="btn btn-success"  onClick={ this.executar }>Executar</button>
                                                    <button type="button" class="btn btn-danger" onClick={ this.voltar }>Limpar</button>                                 
                                                </div>
                                         
                                            </div>
                                         
                                            <div className={`tab-pane ${ !this.state.isPreview ? 'tab-pane fade' : 'fade show active' }`} id="custom-tabs-edicao-dados" role="tabpanel" aria-labelledby="custom-tabs-edicao-dados-tab">
                                                <div class="col-12">
                                                    { 
                                                        this.state.viewReports.length > 0 ?
                                                        <div class="invoice p-3 mb-3">
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <h4>
                                                                        <img src={ Logo } width="120" height="105"/>
                                                                        <small class="float-right">

                                                                            <div className="card-tools">    
                                                                                <button className="btn btn-tool "target="_blank" onClick={ e => this.imprimir( this.state.itens )}>
                                                                                    <i class="fas fa-print"></i> Imprimir
                                                                                </button>                                                        
                                                                                <button type="button" className="btn btn-tool" onClick={ this.voltar }>
                                                                                    <i class="fas fa-reply"></i> Voltar
                                                                                </button>
                                                                            </div>               
                                                                        </small>
                                                                    </h4>
                                                                </div>
                                                                <div class="card-body table-responsive p-0" >
                                                                    <table  class="table table-head-fixed text-nowrap">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Serviço</th>
                                                                                <th>Lavar/Passar</th>
                                                                                <th>Lavar</th>
                                                                                <th>Passar</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                this.state.viewReports.map(item => (
                                                                                            
                                                                                    <tr key={ item.id }>
                                                                                        <td>{ item.nome + " (" + item.codigo + ") " }</td>
                                                                                        <td>{ Number(item.pr1).toFixed(2) }</td>                                                                                    
                                                                                        <td>{ Number(item.pr2).toFixed(2) }</td>                                                                                    
                                                                                        <td>{ Number(item.pr3).toFixed(2) }</td>                                                                                    
                                                                                    </tr>                                                                                     
                                                                                ))
                                                                            }
                                                                            <tr>
                                                                                <td><p>Total Geral: { this.state.viewReports.length }</p></td>
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : 
                                                        <div>
                                                            Nenhuma informação foi encontrada.<br></br>
                                                            <button type="button" class="btn btn-danger" onClick={ this.voltar }>Voltar</button>  

                                                        </div>

                                                    }
                                                </div>
                                            
                                            </div>
                                        </div>     
                                                                          
                                    </div>
                                    {
                                        this.isLoandingPage ?                                    
                                        <div class="overlay d-flex justify-content-center align-items-center">
                                            <i class="fas fa-2x fa-sync fa-spin"></i>
                                        </div>
                                        : ''
                                   
                                    }
                                </div>
                                
                            </div> 
                            <div className="card-footer">                        
                            </div>
                        </div>

                    </section>
                </div>
                
            </div>
        )
    }
        
}

export default RelatorioPorServico;